<template>
  
 
	<section class="dark:bg-gray-800 dark:text-gray-100">
		<div class="container max-w-xl p-6 py-12 mx-auto space-y-24 lg:px-8 lg:max-w-7xl">
			<div>
				<h2 class="text-3xl font-bold tracking-tight text-center sm:text-5xl dark:text-gray-50">{{paramId}}</h2>
				<p class="max-w-3xl mx-auto mt-4 text-xl text-center dark:text-gray-400">A Clinic Event</p>
			</div>
			<div class="grid lg:gap-8 lg:grid-cols-2 lg:items-center">
                <section class="py-6 dark:bg-gray-800 dark:text-gray-50">
		<div class="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4">
			<img src="..\assets\highlight1Thumb.jpg" data-modal-target="modal1" data-modal-toggle="modal1" alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" :src="eventData">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 " src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 " src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 " src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 " src="static.photos/green/200x200/125">
			<img src="..\assets\action\main2.jpg" alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-1 md:row-start-3 dark:bg-gray-500 ">
		</div>
        <h1 class="hubub">Nike Camp at Life Time Fitness in San Clemente, CA - Apr 17/18 2023  </h1>
        <div class="container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4">
			<img src="..\assets\highlight2Thumb.jpg" data-modal-target="modal2" data-modal-toggle="modal2" alt="" class="w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">
			<img alt="" class="w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" src="static.photos/green/200x200/125">			
			
		</div>
	</section>
			</div>
			
		</div>
	</section>

</template>

<script>
import { onMounted, ref } from "@vue/runtime-core"
import { useRoute } from "vue-router"
import { doc, getDoc } from '@firebase/firestore'
import { db } from '@/firebase/config'


export default {
    setup(){
        
        const route = useRoute()
        const eventData = ref('')
        const paramId = ref('')

      
        onMounted(()=>{
            paramId.value = route.params.name
            eventData.value = "https://photos.fife.usercontent.google.com/pw/AP1GczMMAe1IYoz4oAQHC5tFZy3FYls-9TChCZr3-Tfn6tzgtw5XjFlyOTA=w466-h947-s-no?authuser=2"   
        })

        //getImageUrl((name)=> { return new URL('./dir/${name}.png, import.meta.url).href' })

      

        return { paramId, eventData}
    }
    
}
</script>

<style>

</style>